import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProjectGallery } from '../components/ProjectGallery';
import { fetchCategory } from '../lib/portfolio';
import { buildFallbackCategory } from '../lib/fallback';

// Tjänstesida – innehållet hämtas från Supabase med statisk fallback.
export const ServicePage = ({ slug }) => {
  const navigate = useNavigate();
  const [content, setContent] = useState(() => buildFallbackCategory(slug));

  useEffect(() => {
    let mounted = true;
    setContent(buildFallbackCategory(slug));
    fetchCategory(slug).then((c) => mounted && c && setContent(c));
    return () => {
      mounted = false;
    };
  }, [slug]);

  if (!content) return null;

  return (
    <div className="bg-cv-base min-h-screen" style={{ padding: 'clamp(120px,18vw,150px) clamp(20px,5vw,32px) clamp(64px,10vw,96px)' }}>
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-16 flex flex-col items-center gap-[18px]">
          <button onClick={() => navigate('/')} className="bg-none border-none cursor-pointer text-xs tracking-[0.28em] uppercase text-cv-accent p-0">
            ← Tillbaka till Hem
          </button>
          <h1 className="m-0 font-serif font-medium text-cv-ink" style={{ fontSize: 'clamp(32px,5.5vw,48px)' }}>{content.title}</h1>
          <span className="w-14 h-px bg-cv-accent" />
          <p className="m-0 text-base leading-[1.7] text-cv-muted max-w-[62ch]">{content.description}</p>
        </div>

        <h2 className="m-0 mb-8 font-serif font-medium text-[28px] text-cv-ink">{content.sectionTitle}</h2>
        <ProjectGallery projects={content.projects} />

        <div className="text-center mt-20 pt-14 border-t border-cv-border flex flex-col items-center gap-4">
          <h3 className="m-0 font-serif font-medium text-cv-ink" style={{ fontSize: 'clamp(26px,4vw,32px)' }}>Låt oss samarbeta</h3>
          <p className="m-0 text-[15px] leading-[1.7] text-cv-muted max-w-[52ch]">
            Kostnadsfri konsultation där vi diskuterar dina visioner och utforskar hur vi kan förverkliga dem tillsammans.
          </p>
          <button onClick={() => navigate('/kontakt')} className="mt-2 inline-flex items-center gap-3 bg-cv-ink text-cv-base border-none cursor-pointer px-[34px] py-4 text-[13px] tracking-[0.18em] uppercase rounded-cv hover:bg-cv-ink2 transition-colors">
            Boka konsultation <span className="font-serif">→</span>
          </button>
        </div>
      </div>
    </div>
  );
};
